<template lang="html">
    <div style="height:100%;">
        <div class="handleBox flex flex-ai-c">
            <p class="title">团队分红 - 团队盈利设置<i class="el-icon-warning" style="color: #409EFF" @click="dialogFormVisible=true"></i> ></p>
        </div>
		
        <div class="zsBox" v-if="list.length>0">
            <div class="flex zsList" v-for="(item,index) in list" :key="index">
                <div class="flex flex-ai-c">
                    <label>{{item.vip_level_name}}：</label>
                    <el-input v-model="item.ratio" oninput="this.value=this.value > 100 ? 100 :this.value" type="number" max="100" placeholder="" size="small">
						<template slot="append">%</template>
					</el-input>
                </div>
            </div>
            <el-button type="primary" size="small" class="zsBtn" @click="submit">确定</el-button>
        </div>

        <el-dialog title="推广盈利设置" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false" width="400px">
            <div>
                1、资深合伙人、高级合伙人、普通合伙人这三项统一奖励标准。<br>
                2、资深合伙人、高级合伙人、普通合伙人分红比例不一样，需要单独设置，并且三项不能叠加
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogFormVisible:false,
            input: '',
            list: [],
            noEmpty: true
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.http.post('/admin/teamSetting/getDetail').then(re => {
                this.list = re.detail;
            })
        },

        submit() {
            this.noEmpty = true;
            this.list.forEach(v => {
                if (!v.ratio) {
                    this.noEmpty = false;
                }
            })
            if (!this.noEmpty) {
                this.$message.error('不得有为空设置！')
            } else {
                this.http.post('/admin/teamSetting/saveData', {
                    detail:this.list
                }).then(() => {
                    this.getData();
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                })
            }
        }
    }
}
</script>

<style lang="css" scoped>
</style>
